import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { SearchService } from '../../shared/services/search.service';
import { FormsModule } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { UserService } from '../../shared/services/user.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { SearchCriteria } from '../../shared/helpers/search-criteria/search-criteria';
import { SearchResult } from '../../shared/entities/searchResult';
import { ToastrService } from 'ngx-toastr';
import { EnvironmentConfigService } from '../../shared/services/environment-config.service';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';
import { CustomTrimPipe } from './trim.pipe';
import { WhereIsSteelComponent } from '../where-is-steel/where-is-steel.component';

interface Suggestion {
  emailId: string;
  fieldNames: string[];
  searchText: string;
  searchDate: string;
  pageNumber: number;
}
interface HistoryEntries {
  orderSearchHistory: Suggestion[];
  coilSearchHistory: Suggestion[];
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, FormsModule, NgxSpinnerModule, CommonModule, CustomTrimPipe,WhereIsSteelComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  selectedSearch = 1;
  searchText: string = '';
  shouldShowSearchDisclaimer: boolean = true;
  showSuggestion: boolean = false;
  historyData: HistoryEntries = {
    orderSearchHistory: [],
    coilSearchHistory: []
  }
  suggestions: Suggestion[] = [];
  searchCriteria: SearchCriteria = new SearchCriteria();
  userRole: any;
  platform: any;
  checkForOdin:boolean=true;
  constructor(
    public authService: AuthService,
    public router: Router,
    public searchService: SearchService,
    private toastr: ToastrService,
    private msal: MsalService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private measurementsDataService: MeasurementsDataService) { } 

  ngOnInit(): void {
    this.userRole = null;
    this.platform = null;
    this.userService.getProfile()
      .subscribe(profile => { 
        if (profile?.measurementSystem) this.measurementsDataService.setData(profile?.measurementSystem);
        this.authService.loggedInUser.set(profile);
        if (profile) {
          this.userRole = profile?.portalRoles;
          this.platform = profile?.subscribedPlatforms;
          localStorage.setItem("platform", this.platform);
          localStorage.setItem("role", this.userRole);
          if (this.platform?.length != 0) {
            if (this.platform.indexOf('ODIN') > -1 && this.platform.indexOf('DOD') == -1) {
              this.checkForOdin=true;
              this.router.navigate(['where-is-my-steel']);
            }else{
               this.checkForOdin=false;
                 this.router.navigate(['']);
            }
          }
        }
        this.loadHistoryData();
      });


  }

  loadHistoryData() {
    this.http.get<HistoryEntries>(`${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/history`).subscribe(
      (data: HistoryEntries) => {
        this.historyData = data;
        this.suggestions = this.historyData.coilSearchHistory;
      },
      (error) => {
        console.error('Error fetching history data:', error);
      }
    );
  }

  showSuggestions() {
    this.showSuggestion = true;
  }

  hideSuggestions() {
    // Delay hiding suggestion box to handle click events
    setTimeout(() => {
      this.showSuggestion = false;
    }, 200);
  }

  selectSuggestion(suggestion: string, selectedSearch: number) {
    this.searchText = suggestion;
    this.showSuggestion = false;
  }

  // Function to convert camelCase to readable format
  toReadableHistorySuggestionFormat(field: string): string {
    // Use regular expression to insert space before capital letters &&  Convert the first character of each word to uppercase
    return field.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); });
  }

  get username() {
    const userData = this.authService.loggedInUser();
    let uname: string | undefined = '';

    if (userData.firstName && userData.lastName) {
      uname = userData.firstName + ' ' + userData.lastName;
    } else {
      uname = this.msal.instance.getActiveAccount()?.username;
      if (uname) {
        uname = uname?.substring(0, uname.indexOf('@'));
      }
    }

    return uname;
  }

  navigateLogin() {
    this.router.navigate(['login']);
  }

  searchCoilOrOrder(selectedSearch: number) {
    this.selectedSearch = selectedSearch;
    this.searchText = '';
    if (this.selectedSearch === 1) {
      this.suggestions = this.historyData.coilSearchHistory;
    } else {
      this.suggestions = this.historyData.orderSearchHistory;
    }
  }

  searchAndNavigate() {
    if (this.searchCriteria) {
      if (this.selectedSearch === 1) {
        this.searchCoilData(this.searchText, this.shouldShowSearchDisclaimer);
      } else {
        this.searchOrderData(this.searchText, this.shouldShowSearchDisclaimer);
      }
    } else {
      this.toastr.warning(
        'No search result, please change your search criteria'
      );
    }
  }


  searchCoilData(searchText: string, shouldShowSearchDisclaimer: boolean) {
    this.spinner.show();
    let coilSearchCriteria = new SearchCriteria(this.searchText);
    this.searchService.searchCoils(coilSearchCriteria, null).subscribe({
      next: (result: SearchResult) => {
        if (result && result.content.length > 0) {
          this.spinner.hide();
          const navigationExtras: NavigationExtras = { queryParams: { searchText: searchText, shouldShowDisclaimer: shouldShowSearchDisclaimer } };
          this.router.navigate(['coils'], navigationExtras);
        } else {
          this.spinner.hide();
          this.toastr.warning(
            'No search result, please change your search criteria'
          );
        }
      }
    })
  }

  searchOrderData(searchText: string, shouldShowSearchDisclaimer: boolean) {
    this.spinner.show();
    let orderSearchCriteria = new SearchCriteria(this.searchText);
    this.searchService.searchOrders(orderSearchCriteria, null).subscribe({
      next: (result: SearchResult) => {
        if (result && result.content.length > 0) {
          this.spinner.hide();
          const navigationExtras: NavigationExtras = { queryParams: { searchText: searchText, shouldShowDisclaimer: shouldShowSearchDisclaimer } };
          this.router.navigate(['orders'], navigationExtras);
        } else {
          this.spinner.hide();
          this.toastr.warning(
            'No search result, please change your search criteria'
          );
        }
      }
    })
  }
}
